import { Create, useForm } from "@refinedev/antd";
import { HttpError } from "@refinedev/core";
import { ProductInput } from "@src/components/crud-item/product-input";
import { Button, Card, Form } from "antd";
import { TroubleShootingFormFieldsEnum } from "./enums";
import { TimeRangeInput } from "@src/components/crud-item/time-range-input";
import { CountryInput } from "./components/country-input";
import { SelectWithSpinAndCustomMaxTag } from "@src/components/select/SelectWithCustomMaxTag";
import React from "react";
import { MetricDisplayInput } from "./components/metric-display-input";
import { LayersInput } from "./components/layers-input";
import { PredictionViewInput } from "./components/prediction-view-input";
import { LayoutWrapper } from "../intelligence-search-v2/components/crud/layout-wrapper";
import { ExclamationCircleOutlined } from "@ant-design/icons";

export const TroubleShootingCreate = () => {
    const { form } = useForm<any, HttpError, any>();
    const productCodeWatch = Form.useWatch(TroubleShootingFormFieldsEnum.PRODUCT_CODE, form);
    const options = React.useMemo(() => {
        return [
            {
                label: "Android",
                value: productCodeWatch + "a",
            },
            {
                label: "IOS",
                value: productCodeWatch + "i",
            },
        ];
    }, [productCodeWatch]);

    return (
        <Form form={form} layout="vertical">
            <LayoutWrapper
                headerActions={<div />}
                title={<div className="flex flex-col">Trouble Shooting</div>}
                loading={false}
                isDisabled={false}
            >
                <Card>
                    <div className="flex flex-wrap gap-2">
                        <Form.Item name={TroubleShootingFormFieldsEnum.PRODUCT_CODE}>
                            <ProductInput />
                        </Form.Item>
                        <Form.Item name={TroubleShootingFormFieldsEnum.PLATFORM}>
                            <SelectWithSpinAndCustomMaxTag
                                style={{ width: 200 }}
                                mode="multiple"
                                disabled={!productCodeWatch}
                                placeholder="Platform"
                                options={options}
                            />
                        </Form.Item>
                        <Form.Item name={TroubleShootingFormFieldsEnum.TIME_RANGE}>
                            <TimeRangeInput />
                        </Form.Item>
                        <Form.Item label="Country" name={TroubleShootingFormFieldsEnum.COUNTRY_CODE}>
                            <CountryInput placeholder="Select countries" style={{ width: 400 }} />
                        </Form.Item>
                        <Form.Item
                            label="Metric Display Options"
                            name={TroubleShootingFormFieldsEnum.METRIC_PROBLEMS}
                            required
                        >
                            <MetricDisplayInput />
                        </Form.Item>
                        <Form.Item label="Page Layers" name={TroubleShootingFormFieldsEnum.LAYERS} required>
                            <LayersInput />
                        </Form.Item>
                        <Form.Item
                            label="Prediction View"
                            name={TroubleShootingFormFieldsEnum.PREDICTION_VIEW}
                            required
                        >
                            <PredictionViewInput />
                        </Form.Item>
                    </div>
                    <div className="flex gap-4 justify-end">
                        <Button key="reset" type="text">
                            Reset
                        </Button>
                        <Button key="apply-filter" type="primary">
                            Apply Filter
                        </Button>
                    </div>
                </Card>
                <Card className="mt-4 py-10">
                    <div className="flex flex-col items-center gap-2">
                        <ExclamationCircleOutlined className="text-gray-500 text-2xl" />
                        <span className="text-lg font-bold">Awaiting Analysis</span>
                        <span>Please set up your parameters and click "Apply Filters".</span>
                    </div>
                </Card>
            </LayoutWrapper>
        </Form>
    );
};
